export function Grid({
  className = '',
  id = '',
  children
}) {
  return (
    <div className={`flex ${className}`} id={id}>
      {children}
    </div>
  )
}

export function Column({
  className = '',
  children
}) {

  return (
    <div className={`${className}`}>
      {children}
    </div>
  )
}
